var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinLogoAlt = function SvgLinkedinLogoAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LinkedinLogoAlt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.02.23H1.977C1.16.23.5.876.5 1.673v17.113c0 .797.66 1.446 1.477 1.446H19.02c.816 0 1.48-.649 1.48-1.442V1.672c0-.797-.664-1.441-1.48-1.441ZM6.434 17.275h-2.97V7.727h2.97v9.547ZM4.949 6.426a1.72 1.72 0 1 1-.006-3.44 1.72 1.72 0 0 1 .006 3.44Zm12.594 10.848h-2.965v-4.64c0-1.106-.02-2.532-1.543-2.532-1.543 0-1.777 1.207-1.777 2.453v4.719H8.297V7.727h2.844v1.305h.039c.394-.75 1.363-1.543 2.804-1.543 3.004 0 3.559 1.976 3.559 4.547v5.238Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LinkedinLogoAlt_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .23)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgLinkedinLogoAlt;